<template lang="pug">
.communityq-content-type-field
  select.form-control(v-model="selectedIdentifier")
    option
    option(
      v-for="contentType in communityqContentTypesStore.contentTypes"
      :value="contentType.identifier"
      :key="contentType.id"
    )
      | {{ contentType.name }}
</template>

<script>
import { mapStores } from 'pinia'
import { useCommunityqContentTypesStore } from '../../../stores/communityq_content_types'

export default {
  props: {
    publicationId: {
      required: true,
      type: Number
    },
    value: {
      type: String,
      required: false
    }
  },

  computed: {
    ...mapStores(useCommunityqContentTypesStore),

    selectedIdentifier: {
      get() { return this.value },
      // Emits the value to support usage with v-model. The change will then
      //flow back down through the value prop, so we don't need to set it here.
      set(val) { this.$emit('input', val); }
    }
  },

  mounted() {
    this.communityqContentTypesStore.fetch(this.publicationId)
  }
}
</script>
